import { useTranslation } from 'react-i18next'
import { Card, CardContent } from '@meno/ui/components/ui/card'
import { BookOpen } from 'lucide-react'
import { usePageHeader } from '@meno/ui/components/layout/PageHeader'

// Tutorials — promoted out of Settings into its own sidebar destination.
// A signage-specific grid of guided walkthroughs (bilingual EN/AR copy).
export default function TutorialsPage() {
  const { t } = useTranslation()
  usePageHeader({ title: t('settings.tutorials.title', 'Frame Tutorials') })

  const tutorials = [
    { title: t('settings.tutorials.gettingStarted', 'Getting Started'),          desc: t('settings.tutorials.gettingStartedDesc', 'Pair your first screen and go live in minutes') },
    { title: t('settings.tutorials.managingScreens', 'Managing Screens'),        desc: t('settings.tutorials.managingScreensDesc', 'Add, group, configure and monitor your screens') },
    { title: t('settings.tutorials.creatingMenus', 'Creating Menus'),            desc: t('settings.tutorials.creatingMenusDesc', 'Design and publish digital menus to your screens') },
    { title: t('settings.tutorials.buildingLayouts', 'Building Layouts'),        desc: t('settings.tutorials.buildingLayoutsDesc', 'Use the drag-and-drop builder to design screen layouts') },
    { title: t('settings.tutorials.mediaPlaylists', 'Media & Playlists'),        desc: t('settings.tutorials.mediaPlaylistsDesc', 'Upload media and schedule playlists across your screens') },
    { title: t('settings.tutorials.realTimeMonitoring', 'Real-time Monitoring'), desc: t('settings.tutorials.realTimeMonitoringDesc', 'Track screen status live and manage publishing tasks') },
  ]

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">{t('settings.tutorials.subtitle')}</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {tutorials.map(tut => (
          <Card key={tut.title} className="bg-card hover:border-primary/50 transition-colors cursor-pointer">
            <CardContent className="p-4">
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-lg bg-muted">
                  <BookOpen className="w-4 h-4 text-primary" />
                </div>
                <div>
                  <p className="font-medium text-sm">{tut.title}</p>
                  <p className="text-xs text-muted-foreground">{tut.desc}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  )
}
